import React from 'react';
import {useProviderProfile} from "../../../../ProviderProfileProvider";
import {TabbedPageHeader} from '../../../../components/TabbedPageHeader';
import {KensuTable} from "../../../../components/table/KensuTable";
import {useNavigateWithParams} from "../../../../util/NavUtils";
import {useProfileTabs} from "./ProfileRouter";

export const Locations = () => {

  const {businessProfile} = useProviderProfile();
  const navigate = useNavigateWithParams();
  const profileTabs = useProfileTabs();

  return <div className={'NonScrollingToolPage'}>

    <TabbedPageHeader pageTitle={'Business Profile'}
                      buttons={[{text: 'Add Location', link: 'add'}]}
                      tabs={profileTabs}
    />

    < div className={'ProviderToolAreaContent'}>

      <KensuTable
          data={businessProfile?.locations}
          onRowSelected={(row) => navigate(`edit/${row.locationId}`)}
          columns={[{
            label: 'Name',
            render: r => r.locationName,
            showArchivedBadge: r => r.archived,
            sortString: r => r.locationName
          },
            {label: 'Address', render: r => r.physicalLocation?.address},
            {label: 'Phone', render: r => r.physicalLocation?.phone},
          ]}
      />

      {!businessProfile?.locations?.length && <div>
        <br/><br/>
        You haven’t added a location yet — click <b>“Add”</b> above to get started.
      </div>}
    </div>
  </div>

};

